import { Action, createReducer, on } from '@ngrx/store';
import { IBenchmark } from '../models/benckmark.model';
import * as productSolution from '../actions';

export const getBenchmarksFeatureKey = 'getBenchmarks';

export interface State {
  loaded: boolean;
  error?: Error | any;
  benchmarks: IBenchmark[];
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  benchmarks: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    productSolution.loadGetBenchmarks,

    state => state
  ),
  on(productSolution.loadGetBenchmarksSuccess, (state, action) => ({
    ...state,
    benchmarks: action.response,
    loaded: true
  })),

  on(productSolution.loadGetBenchmarksFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectBenchmarks = (state: State) => state.benchmarks;
export const selectBenchmarksLoaded = (state: State) => state.loaded;
export const selectBenchmarksError = (state: State) => state.error;
